import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["link", "checkbox"]

  connect() {
    const csrfTag = document.querySelector('meta[name=csrf-token]');
    this.csrfToken = csrfTag ? (csrfTag : any).content : "";
  }

  click(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.checkboxTarget.disabled) return;
    this.checkboxTarget.disabled = true;

    const checked = e.target === this.checkboxTarget ? !this.checkboxTarget.checked : this.checkboxTarget.checked;

    fetch(this.linkTarget.href, { method: checked ? "DELETE" : "POST", headers: { "X-CSRF-Token": this.csrfToken } })
      .then(response => {
        if (response.ok) {
          this.checkboxTarget.checked = !checked;
          this.checkboxTarget.disabled = false;
        }
      });
  }
}
